function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var fs = require('fs');
var path = require('path');
var HomePage = require('./index');
var SaitoEvent = require('./../saito/ui/saito-calendar/saito-calendar-event-link');
var JSON = require('json-bigint');
var ModTemplate = /*#__PURE__*/function () {
  function ModTemplate(app, mod) {
    _classCallCheck(this, ModTemplate);
    this.app = app || {};
    this.description = '';
    this.dirname = '';
    this.appname = '';
    this.name = '';
    this.dbname = ''; // slug by default
    this.slug = '';
    this.link = '';
    this.img = ''; // usually link or base64 image
    this.teaser = false; // teaser module, non-function but displays in arcade/appstore w/ install link
    this.events = []; // events to which i respond
    this.renderIntos = {};
    this.alerts = 0;
    this.categories = '';
    this.sqlcache = {};
    this.sqlcache_enabled = 0;
    this.services = [];
    this.components = []; // modules or UI objects
    this.request_no_interrupts = false; // if you don't want your module to have other modules insert HTML components, you can request it here.
    this.db_tables = [];
    this.urlpath = [];
    this.version = 1.0;
    this.meta = [];
    this.styles = [];
    this.scripts = [];
    this.includes_attached = 0;
    this.eventListeners = [];
    this.theme_options = {
      lite: 'fa-solid fa-sun',
      raven: 'fa-solid fa-crow',
      dark: 'fa-solid fa-moon',
      prism: 'fa-solid fa-gem'
    };
    this.processedTxs = {};
    this.parameters = {};

    // A module which wishes to be rendered in the client can either define
    // it's own webServer function or simply include it's own web directory
    // which will automatically be served by the Saito Core's server.
    // If neither exist, it will default to a blank page distinct from the 404 not found
    this.default_html = 1;

    // browser active will be set by Saito Client if the module name matches
    // the current path. e.g. when the user is at /chat, chat.js which has
    // this.name = "chat", will have this.browser_active = 1;
    this.browser_active = 0;

    // Some modules are "home pages" and serve as a launching pad for other apps
    // We want to remember the user's preferred home (i.e. Arcade or Redsquare) to return
    // them to when exiting a non-home module
    this.possibleHome = 0;
    this.publicKey = '';
    // this.darkModeToggler = new Toggler(app);
  }

  ////////////////////////////
  // Extend these Functions //
  ////////////////////////////
  //
  // INSTALL MODULE
  //
  // this callback is run the first time the module is loaded. You
  // can override this callback in your module if you would like,
  // but should be a bit careful to include this line at the top:
  //
  //   await super.installModule(app);
  //
  // ... if you want to keep the default functionality of auto-
  // creating a database with the necessary tables on install
  // if it does not exist.
  //
  return _createClass(ModTemplate, [{
    key: "installModule",
    value: function () {
      var _installModule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var sqldir, fs, dbname, sql_files, i, filename, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.app.BROWSER === 1)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              //
              // does this require database installation
              //
              sqldir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/sql");
              fs = app.storage.returnFileSystem();
              dbname = encodeURI(this.returnSlug());
              if (this.dbname) {
                dbname = this.dbname;
              }
              if (!(fs != null)) {
                _context.n = 7;
                break;
              }
              if (!fs.existsSync(path.normalize(sqldir))) {
                _context.n = 7;
                break;
              }
              //
              // get all files in directory
              //
              sql_files = fs.readdirSync(sqldir).sort();
              i = 0;
            case 2:
              if (!(i < sql_files.length)) {
                _context.n = 7;
                break;
              }
              _context.p = 3;
              filename = path.join(sqldir, sql_files[i]);
              data = fs.readFileSync(filename, 'utf8');
              _context.n = 4;
              return app.storage.executeDatabase(data, dbname);
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
            case 6:
              i++;
              _context.n = 2;
              break;
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5]]);
      }));
      function installModule(_x) {
        return _installModule.apply(this, arguments);
      }
      return installModule;
    }()
  }, {
    key: "initialize",
    value:
    //
    // INITIALIZE
    //
    // this callback is run every time the module is initialized. It
    // takes care of the events to which we want to listen by default
    // so if you over-write it, be careful to include this line at
    // the top:
    //
    //    await super.initialize(app);
    //
    // that will ensure default behavior appies to inherited modules
    // and the sendEvent and receiveEvent functions will still work
    //
    function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this = this,
          _app$storage;
        var _loop, i, _app$options$settings, current_url, myurl, myurlpath, sqldir, fs, sql_files, _i, tablename;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.app.wallet.getPublicKey();
            case 1:
              this.publicKey = _context3.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(i) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      app.connection.on(_this.events[i], function (data) {
                        _this.receiveEvent(_this.events[i], data);
                      });
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < this.events.length)) {
                _context3.n = 4;
                break;
              }
              return _context3.d(_regeneratorValues(_loop(i)), 3);
            case 3:
              i++;
              _context3.n = 2;
              break;
            case 4:
              if (!(app.BROWSER === 1)) {
                _context3.n = 5;
                break;
              }
              if (this.browser_active) {
                if (app.browser.returnURLParameter('debug')) {
                  console.debug('Dynamically set debug flag true in ' + this.name);
                  this.debug = true;
                }
                if ((_app$options$settings = app.options.settings) !== null && _app$options$settings !== void 0 && _app$options$settings.debug) {
                  console.debug('Set debug flag true from options file ' + this.name);
                  this.debug = true;
                }
              }

              //what is this?
              current_url = window.location.toString();
              myurl = new URL(current_url);
              myurlpath = myurl.pathname.split('/');
              this.urlpath = myurlpath;

              //
              // browsers should not handle db tables
              //
              return _context3.a(2);
            case 5:
              //
              // create list of tables for auto-db response
              //
              sqldir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/sql");
              fs = app === null || app === void 0 || (_app$storage = app.storage) === null || _app$storage === void 0 ? void 0 : _app$storage.returnFileSystem();
              if (fs != null) {
                if (fs.existsSync(path.normalize(sqldir))) {
                  //
                  // get all files in directory
                  //
                  sql_files = fs.readdirSync(sqldir);
                  for (_i = 0; _i < sql_files.length; _i++) {
                    //
                    // adding table to database
                    //
                    tablename = sql_files[_i].slice(0, -4); //
                    // remove digits from end, used as we sometimes
                    // use numbers at end of sql file to order indexes
                    // or run post-processing on table create and need
                    // guaranteed order
                    //
                    tablename = tablename.replace(/\d+$/, '');
                    this.db_tables.push(tablename);
                  }
                }
              }
              if (this.appname === '') {
                this.appname = this.name;
              }
            case 6:
              return _context3.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() //
    // RENDER
    //
    // adds elements to the DOM and then attaches events to them as needed.
    // this replaces initializeHTML and attachEvents with a single function
    //
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$styles, _this$scripts, _this$postScripts, i, event;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (this.browser_active && this.possibleHome) {
                this.app.options.homeModule = this.returnName();
                this.app.storage.saveOptions();
              }
              if (this.includes_attached === 0) {
                if (this.meta) {
                  this.attachMeta();
                }
                if (((_this$styles = this.styles) === null || _this$styles === void 0 ? void 0 : _this$styles.length) > 0) {
                  this.attachStyleSheets();
                }
                if (((_this$scripts = this.scripts) === null || _this$scripts === void 0 ? void 0 : _this$scripts.length) > 0) {
                  console.debug('attachScripts in ' + this.name, this.scripts);
                  this.attachScripts();
                }
                if (((_this$postScripts = this.postScripts) === null || _this$postScripts === void 0 ? void 0 : _this$postScripts.length) > 0) {
                  this.attachPostScripts();
                }
                this.includes_attached = 1;
              }
              i = 0;
            case 1:
              if (!(i < this.components.length)) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return this.components[i].render();
            case 2:
              i++;
              _context4.n = 1;
              break;
            case 3:
              if (this.app.browser.returnURLParameter('event')) {
                event = JSON.parse(this.app.crypto.base64ToString(this.app.browser.returnURLParameter('event')));
                if (!(this !== null && this !== void 0 && this.eventOverlay)) {
                  this.eventOverlay = new SaitoEvent(this.app, this, event);
                  this.eventOverlay.render();
                }
              }
            case 4:
              return _context4.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "returnName",
    value: function returnName() {
      if (this.appname) {
        return this.appname;
      }
      if (this.gamename) {
        return this.gamename;
      }
      if (this.name) {
        return this.name;
      }
      return 'Unknown Module';
    }
  }, {
    key: "returnTitle",
    value: function returnTitle() {
      if (this.title) {
        return this.title;
      }
      return this.returnName();
    }
  }, {
    key: "returnImage",
    value: function returnImage() {
      if (this.img != '') {
        return this.img;
      }
      return "/saito/img/dreamscape.png";
    }
  }, {
    key: "returnBanner",
    value: function returnBanner() {
      return "/saito/img/dreamscape.png";
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return false;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {}

    //
    // INITIALIZE HTML (deprecated by render(app))
    //
  }, {
    key: "initializeHTML",
    value: function () {
      var _initializeHTML = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              return _context5.a(2);
          }
        }, _callee4);
      }));
      function initializeHTML(_x3) {
        return _initializeHTML.apply(this, arguments);
      }
      return initializeHTML;
    }() //
    // ATTACH EVENTS (deprecated by render(app))
    //
    // this callback attaches the javascript interactive bindings to the
    // DOM, allowing us to incorporate the web applications to our own
    // internal functions and send and receive transactions natively.
    //
  }, {
    key: "attachEvents",
    value: function attachEvents(app) {}

    //
    // RECEIVE NFT
    //
    // this callback is run whenever a module receives an NFT that indicates it is owned
    // or controlled by the module in question. Override this to implement custom-code
    // that examines the NFT and determines how-and-if it should be used.
    //
  }, {
    key: "receiveNFT",
    value: function receiveNFT() {
      var nft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    }

    //
    // ON CONFIRMATION
    //
    // this callback is run every time a block receives a confirmation.
    // this is where the most important code in your module should go,
    // listening to requests that come in over the blockchain and replying.
    //
    // By convention Saito Core will fire the onConfirmation for any modules
    // whose name matches tx.msg.module. Other modules which are also interested
    // in those transcations can also subscribe to those confirmations by
    // by using shouldAffixCallbackToModule.
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(blk, tx, confnum) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              return _context6.a(2);
          }
        }, _callee5);
      }));
      function onConfirmation(_x4, _x5, _x6) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }() //
    // some UI elements may provide special display options for modules which
    // have pending actions that require user review or action, such as Redsquare
    // with Tweets, or Games with pending game moves from the player.
    //
  }, {
    key: "returnNumberOfNotifications",
    value: function returnNumberOfNotifications() {
      return 0;
    }

    //
    //
    // ON NEW BLOCK
    //
    // this callback is run every time a block is added to the longest_chain
    // it differs from the onConfirmation function in that it is not linked to
    // individual transactions -- i.e. it will only be run once per block, while
    // the onConfirmation function is run by every TRANSACTION tagged as
    // this is where the most important code in your module should go,
    // listening to requests that come in over the blockchain and replying.
    //
  }, {
    key: "onNewBlock",
    value: function onNewBlock(blk, lc) {}

    //
    //
    //
    // ON CHAIN REORGANIZATION
    //
    // this callback is run everytime the chain is reorganized, for every block
    // with a status that is changed. so it is invoked first to notify us when
    // longest_chain is set to ZERO as we unmark the previously dominant chain
    // and then it is run a second time setting the LC to 1 for all of the
    // blocks that are moved (back?) into the longest_chain
    //
  }, {
    key: "onChainReorganization",
    value: function onChainReorganization(block_id, block_hash, lc) {}

    //
    //
    //
    // ON (WALLET) UPGRADE
    //
    // this function runs if the wallet is upgraded or reset
    //
  }, {
    key: "onUpgrade",
    value: function () {
      var _onUpgrade = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var type,
          privatekey,
          walletfile,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              type = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : '';
              privatekey = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : '';
              walletfile = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : null;
              _context7.n = 1;
              return this.app.wallet.getPublicKey();
            case 1:
              this.publicKey = _context7.v;
            case 2:
              return _context7.a(2);
          }
        }, _callee6, this);
      }));
      function onUpgrade() {
        return _onUpgrade.apply(this, arguments);
      }
      return onUpgrade;
    }() //
    //
    //
    // ON PEER HANDSHAKE COMPLETE -- deprecated
    //
    // this function runs when a node completes its handshake with another peer
  }, {
    key: "onPeerHandshakeComplete",
    value: function onPeerHandshakeComplete(app) {
      var peer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    }

    //
    // ON PEER SERVICE UP
    //
    // this is intended as an initialization function.
    //
    // when a peer connects and completes its handshake, this fires so modules can
    // fetch service-level data like DNS information instead of having to blindly
    // guess or manually examine their peers.
    //
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app, peer, service) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              return _context8.a(2);
          }
        }, _callee7);
      }));
      function onPeerServiceUp(_x7, _x8, _x9) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() //
    //
    // ON CONNECTION STABLE
    //
    // this function runs "connect" event
  }, {
    key: "onConnectionStable",
    value: function onConnectionStable(app, peer) {}

    //
    //
    // ON CONNECTION UNSTABLE
    //
    // this function runs "disconnect" event
  }, {
    key: "onConnectionUnstable",
    value: function onConnectionUnstable(app, publicKey) {}

    // fires when a stun peer has been disconnected
  }, {
    key: "onStunPeerDisconnected",
    value: function onStunPeerDisconnected(app) {
      var peer_index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var public_key = arguments.length > 2 ? arguments[2] : undefined;
    }

    //
    // SHOULD AFFIX CALLBACK TO MODULE
    //
    // sometimes modules want to run the onConfirmation function for transactions
    // that belong to OTHER modules. onConfirmation will be fired automatically
    // for any module whose name matches tx.msg.module. Other modules who are
    // interested in those transactions can use this method to subscribe to those
    // onConfirmation events. See onConfirmation for more details.
    //
    // An example is a server that wants to monitor
    // AUTH messages, or a module that needs to parse third-party email messages
    // for custom data processing.
    //
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (modname === this.name) {
        return 1;
      }
      return 0;
    }

    //
    // SERVER
    //
    // this callback allows the module to serve pages through the main application
    // server, by listening to specific route-requests and serving data from its own
    // separate web directory.
    //
    // This can be overridden to provide advanced interfaces, for example you may
    // want to create a module which serves JSON objects as an RESTFUL API. See
    // Express.js for details.
    //
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var _app$storage2;
      //
      // if a web directory exists, we make it broswable if server
      // functionality exists on this machine. the contents of the
      // web directory will be in a subfolder under the client name
      //
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var fs = app === null || app === void 0 || (_app$storage2 = app.storage) === null || _app$storage2 === void 0 ? void 0 : _app$storage2.returnFileSystem();
      if (fs !== null && fs !== void 0 && fs.existsSync(webdir)) {
        expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
      } else if (this.default_html) {
        // We don't have a static web directory to serve, but we can generate a basic blank html page

        var mod_self = this;
        expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(req, res) {
            var reqBaseURL, html;
            return _regenerator().w(function (_context9) {
              while (1) switch (_context9.n) {
                case 0:
                  reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                  html = HomePage(app, mod_self, app.build_number);
                  if (res.finished) {
                    _context9.n = 1;
                    break;
                  }
                  res.setHeader('Content-type', 'text/html');
                  res.charset = 'UTF-8';
                  return _context9.a(2, res.send(html));
                case 1:
                  return _context9.a(2);
              }
            }, _callee8);
          }));
          return function (_x0, _x1) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }

    //
    // UPDATE BLOCKCHAIN SYNC
    //
    // this callback is run to notify applications of the state of
    // blockchain syncing. It will be triggered on startup and with
    // every additional block added.
    //
  }, {
    key: "updateBlockchainSync",
    value: function updateBlockchainSync(app, current, target) {}

    /////////////////////////
    // MODULE INTERACTIONS //
    /////////////////////////
    //
    // these functions allow your module to communicate and interact with
    // other modules. They automate issuing and listening to events and
    // allow modules to respond to requests from other modules by returning
    // data objects that can be used to update the DOMS managed by other
    // modules.
    //

    //
    // modules may ask other modules to respond to "request_types". The
    // response that they get may or may not be suitable, but if suitable
    // can be used by the requesting module to format data or update
    // its DOM as needed. This is a basic method of providing inter-app
    // interactivity and extensibility.
    //
  }, {
    key: "addScript",
    value: function addScript(s) {
      for (var i = 0; i < this.scripts.length; i++) {
        if (this.scripts[i] === s) {
          return;
        }
      }
      this.scripts.push(s);
    }
  }, {
    key: "addStyle",
    value: function addStyle(s) {
      for (var i = 0; i < this.styles.length; i++) {
        if (this.styles[i] === s) {
          return;
        }
      }
      this.styles.push(s);
    }
  }, {
    key: "addComponent",
    value: function addComponent(obj) {
      for (var i = 0; i < this.components.length; i++) {
        if (this.components[i] === obj) {
          return;
        }
      }
      this.components.push(obj);
    }
  }, {
    key: "removeComponent",
    value: function removeComponent(obj) {
      for (var i = this.components.length; i >= 0; i--) {
        if (this.components[i] === obj) {
          this.components.splice(i, 1);
        }
      }
    }

    //
    //
    // a convenient function that lets other modules know you can or
    // cannot render into them on request. this is used to generate a
    // list of modules for creation of things like menu components where
    // the actual rendering happens post content selection.
    //
  }, {
    key: "canRenderInto",
    value: function canRenderInto() {
      var querySelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return false;
    }

    //
    //
    // modules may ask other modules if they want to insert any components
    // into a UI element like "appspace". This provides a simple way for
    // modules to respond. the expectation is that any UI Components are
    // created by the receiving module and the querySelector is provided
    // to them as a container so they render properly into the right
    // component.
    //
    // modules should cache components in this.renderIntos and render()
    // existing components rather than new ones to avoid the creation of
    // multiple components with parallel event-listeners, etc.
    //
  }, {
    key: "renderInto",
    value: function () {
      var _renderInto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var querySelector,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              querySelector = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : '';
              return _context0.a(2, null);
          }
        }, _callee9);
      }));
      function renderInto() {
        return _renderInto.apply(this, arguments);
      }
      return renderInto;
    }() //
    //
    // modules may ask other modules to respond to "request_types". The
    // response that they get may or may not be suitable, but if suitable
    // can be used by the requesting module to format data or update
    // its DOM as needed. This is a basic method of providing inter-app
    // interactivity and extensibility.
    //
  }, {
    key: "respondTo",
    value: function respondTo() {
      var request_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      return null;
    }

    //
    // DEPRECATED -- port to app.connection.on('event', function...
    //
    // when an event to which modules are listening triggers, we push the
    // data out into this function, which can be overridden as needed in
    // order to
    //
  }, {
    key: "receiveEvent",
    value: function receiveEvent(eventname, data) {}

    //
    // DEPRECATED -- port to app.connection.emit('event', {});
    //
    // you probably don't want to over-write this, it is basicaly just
    // simplifying the event-emitting and receiving functionality in the
    // connection class, so that developers can use this without worrying
    // about their own events.
    //
  }, {
    key: "sendEvent",
    value: function sendEvent(eventname, data) {
      this.app.connection.emit(eventname, data);
    }

    //
    // HANDLE PEER TRANSACTION
    //
    // if your web application defines a lower-level massage format, it can
    // send and receive data WITHOUT the need for that data to be confirmed
    // in the blockchain. See our search module for an example of this in
    // action. This is useful for applications that are happy to pass data
    // directly between peers, but still want to use the blockchain for peer
    // discovery (i.e. "what is your IP address" requests)
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          i,
          _txmsg,
          expected_request,
          _txmsg$data,
          _txmsg$data2,
          _txmsg$data3,
          _txmsg$data4,
          select,
          dbname,
          tablename,
          where,
          sql,
          params,
          rows,
          res,
          txreq,
          _txmsg2,
          _txmsg3,
          _txmsg4,
          _sql,
          _dbname,
          _params,
          _rows,
          _res,
          _args1 = arguments,
          _t2;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              tx = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : null;
              peer = _args1.length > 2 ? _args1[2] : undefined;
              mycallback = _args1.length > 3 && _args1[3] !== undefined ? _args1[3] : null;
              if (!(tx == null)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, 0);
            case 1:
              _context1.p = 1;
              txmsg = tx.returnMessage();
              _context1.n = 3;
              break;
            case 2:
              _context1.p = 2;
              _t2 = _context1.v;
              return _context1.a(2, 0);
            case 3:
              i = 0;
            case 4:
              if (!(i < this.db_tables.length)) {
                _context1.n = 11;
                break;
              }
              expected_request = this.name.toLowerCase() + ' load ' + this.db_tables[i];
              if (!(((_txmsg = txmsg) === null || _txmsg === void 0 ? void 0 : _txmsg.request) === expected_request)) {
                _context1.n = 10;
                break;
              }
              console.trace('expected_request : ' + expected_request);
              select = (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.select;
              dbname = (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.dbname;
              tablename = (_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.tablename;
              where = (_txmsg$data4 = txmsg.data) === null || _txmsg$data4 === void 0 ? void 0 : _txmsg$data4.where;
              if (/^[a-z"`'=_*()\.\n\t\r ,0-9A-Z]+$/.test(select)) {
                _context1.n = 5;
                break;
              }
              return _context1.a(2);
            case 5:
              if (/^[a-z"`'=_()\. ,0-9A-Z]+$/.test(dbname)) {
                _context1.n = 6;
                break;
              }
              return _context1.a(2);
            case 6:
              if (/^[a-z"`'=_()\. ,0-9A-Z]+$/.test(tablename)) {
                _context1.n = 7;
                break;
              }
              return _context1.a(2);
            case 7:
              sql = "SELECT ".concat(select, "\n                   FROM ").concat(tablename);
              if (where !== '') {
                sql += " WHERE ".concat(where);
              }
              params = {};
              _context1.n = 8;
              return this.app.storage.queryDatabase(sql, params, dbname);
            case 8:
              rows = _context1.v;
              res = {};
              res.err = '';
              res.rows = rows;
              if (!mycallback) {
                _context1.n = 9;
                break;
              }
              mycallback(res);
              return _context1.a(2, 1);
            case 9:
              return _context1.a(2, 0);
            case 10:
              i++;
              _context1.n = 4;
              break;
            case 11:
              //
              // odd error previously if referencing txmsg.request directly
              // webpack seems to struggle for some reason. suggest extracting
              // value and then running a string comparison this way.
              //
              txreq = txmsg.request;
              if (!(txreq === 'rawSQL')) {
                _context1.n = 16;
                break;
              }
              if (!(((_txmsg2 = txmsg) === null || _txmsg2 === void 0 || (_txmsg2 = _txmsg2.data) === null || _txmsg2 === void 0 ? void 0 : _txmsg2.module) === this.name)) {
                _context1.n = 16;
                break;
              }
              _sql = (_txmsg3 = txmsg) === null || _txmsg3 === void 0 || (_txmsg3 = _txmsg3.data) === null || _txmsg3 === void 0 ? void 0 : _txmsg3.sql;
              _dbname = (_txmsg4 = txmsg) === null || _txmsg4 === void 0 || (_txmsg4 = _txmsg4.data) === null || _txmsg4 === void 0 ? void 0 : _txmsg4.dbname;
              _params = {};
              if (!(this.sqlcache[_sql] && this.sqlcache_enabled === 1)) {
                _context1.n = 12;
                break;
              }
              _rows = this.sqlcache[_sql];
              _context1.n = 14;
              break;
            case 12:
              _context1.n = 13;
              return this.app.storage.queryDatabase(_sql, _params, _dbname);
            case 13:
              _rows = _context1.v;
              if (this.sqlcache_enabled) {
                this.sqlcache[_sql] = _rows;
              }
            case 14:
              _res = {};
              _res.err = '';
              _res.rows = _rows;
              if (!mycallback) {
                _context1.n = 15;
                break;
              }
              mycallback(_res);
              return _context1.a(2, 1);
            case 15:
              return _context1.a(2, 0);
            case 16:
              return _context1.a(2, 0);
          }
        }, _callee0, this, [[1, 2]]);
      }));
      function handlePeerTransaction(_x10) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      return this.services;
    }

    //
    // PEER DATABASE CHECK
    //
    // this piggybacks on handlePeerRequest to provide automated database
    // row-retrieval for clients who are connected to servers that run the
    // data silos.
    //
  }, {
    key: "sendPeerDatabaseRequest",
    value: function () {
      var _sendPeerDatabaseRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(dbname, tablename) {
        var select,
          where,
          peer,
          mycallback,
          message,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              select = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : '';
              where = _args10.length > 3 && _args10[3] !== undefined ? _args10[3] : '';
              peer = _args10.length > 4 && _args10[4] !== undefined ? _args10[4] : null;
              mycallback = _args10.length > 5 && _args10[5] !== undefined ? _args10[5] : null;
              message = {};
              message.request = dbname + ' load ' + tablename;
              message.data = {};
              message.data.dbname = dbname;
              message.data.tablename = tablename;
              message.data.select = select;
              message.data.where = where;
              if (!(peer == null)) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2, this.app.network.sendRequestAsTransaction(message.request, message.data, function (res) {
                return mycallback(res);
              }));
            case 1:
              return _context10.a(2, this.app.network.sendRequestAsTransaction(message.request, message.data, function (res) {
                return mycallback(res);
              }, peer.publicKey));
            case 2:
              return _context10.a(2);
          }
        }, _callee1, this);
      }));
      function sendPeerDatabaseRequest(_x11, _x12) {
        return _sendPeerDatabaseRequest.apply(this, arguments);
      }
      return sendPeerDatabaseRequest;
    }()
  }, {
    key: "sendPeerDatabaseRequestWithFilter",
    value: function () {
      var _sendPeerDatabaseRequestWithFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var modname,
          sql,
          success_callback,
          peerfilter,
          msg,
          _args11 = arguments;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              modname = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : '';
              sql = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : '';
              success_callback = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : null;
              peerfilter = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : null;
              if (!(sql === '')) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              if (!(modname === '')) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              if (this.app.modules.returnModule(modname)) {
                _context11.n = 3;
                break;
              }
              console.error(modname + ' not found!');
              return _context11.a(2);
            case 3:
              msg = {};
              msg.request = 'rawSQL';
              msg.data = {};
              msg.data.sql = sql;
              msg.data.module = modname;
              msg.data.dbname = this.app.modules.returnModule(modname).returnSlug();
              this.sendPeerRequestWithFilter(function () {
                return msg;
              }, success_callback, peerfilter);
            case 4:
              return _context11.a(2);
          }
        }, _callee10, this);
      }));
      function sendPeerDatabaseRequestWithFilter() {
        return _sendPeerDatabaseRequestWithFilter.apply(this, arguments);
      }
      return sendPeerDatabaseRequestWithFilter;
    }()
  }, {
    key: "sendPeerRequestWithServiceFilter",
    value: function () {
      var _sendPeerRequestWithServiceFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(servicename, msg) {
        var success_callback,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              success_callback = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : function (res) {};
              this.sendPeerRequestWithFilter(function () {
                return msg;
              }, success_callback, function (peer) {
                if (peer.services) {
                  for (var z = 0; z < peer.services.length; z++) {
                    if (peer.services[z].service === servicename) {
                      return 1;
                    }
                  }
                }
              });
            case 1:
              return _context12.a(2);
          }
        }, _callee11, this);
      }));
      function sendPeerRequestWithServiceFilter(_x13, _x14) {
        return _sendPeerRequestWithServiceFilter.apply(this, arguments);
      }
      return sendPeerRequestWithServiceFilter;
    }()
  }, {
    key: "sendPeerRequestWithFilter",
    value: function () {
      var _sendPeerRequestWithFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var msg_callback,
          success_callback,
          peerfilter,
          message,
          p,
          peers,
          i,
          _i2,
          _peers,
          peer,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              msg_callback = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : null;
              success_callback = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
              peerfilter = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : null;
              message = msg_callback();
              if (!(message === null)) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2);
            case 1:
              _context13.n = 2;
              return this.app.network.getPeers();
            case 2:
              p = _context13.v;
              peers = [];
              for (i = 0; i < p.length; i++) {
                if (!peerfilter || peerfilter(p[i])) {
                  peers.push(p[i]);
                }
              }
              if (!(peers.length === 0)) {
                _context13.n = 3;
                break;
              }
              console.warn('sendPeerRequestWithFilter found no peers');
              return _context13.a(2);
            case 3:
              for (_i2 = 0, _peers = peers; _i2 < _peers.length; _i2++) {
                peer = _peers[_i2];
                this.app.network.sendRequestAsTransaction(message.request, message.data, function (res) {
                  if (success_callback != null) {
                    success_callback(res);
                  }
                }, peer.publicKey);
              }
            case 4:
              return _context13.a(2);
          }
        }, _callee12, this);
      }));
      function sendPeerRequestWithFilter() {
        return _sendPeerRequestWithFilter.apply(this, arguments);
      }
      return sendPeerRequestWithFilter;
    }()
  }, {
    key: "sendPeerDatabaseRequestRaw",
    value: function () {
      var _sendPeerDatabaseRequestRaw = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(db, sql) {
        var mycallback,
          message,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              mycallback = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : null;
              message = {};
              message.request = 'rawSQL';
              message.data = {};
              message.data.sql = sql;
              message.data.dbname = db;
              message.data.module = this.name;
              return _context14.a(2, this.app.network.sendRequestAsTransaction(message.request, message.data, function (res) {
                //JSON.stringify("callback data1: " + JSON.stringify(res));
                return mycallback(res);
              }));
          }
        }, _callee13, this);
      }));
      function sendPeerDatabaseRequestRaw(_x15, _x16) {
        return _sendPeerDatabaseRequestRaw.apply(this, arguments);
      }
      return sendPeerDatabaseRequestRaw;
    }()
  }, {
    key: "activateModule",
    value: function activateModule() {
      if (!this.app.BROWSER) {
        console.error('Attempting to set browser_active on a non-browser node!');
        return;
      }
      this.browser_active = 1;
      this.alerts = 0;
    }
  }, {
    key: "isSlug",
    value: function isSlug(slug) {
      return slug == this.returnSlug();
    }
  }, {
    key: "returnSlug",
    value: function returnSlug() {
      if (this.slug !== '') {
        return this.slug;
      } else {
        if (this.appname) {
          this.slug = this.appname.toLowerCase();
        } else {
          this.slug = this.name.toLowerCase();
        }
        this.slug = this.slug.replace(/\t/g, '_').replace(/\ /g, '');
        return this.slug;
      }
    }
  }, {
    key: "returnLink",
    value: function returnLink() {
      if (this.link !== '') {
        return this.link;
      } else {
        this.link = '/' + this.returnSlug();
        return this.link;
      }
    }
  }, {
    key: "showAlert",
    value: function showAlert() {
      this.alerts++;
      try {
        var qs = '#' + this.returnSlug() + ' > .redicon';
        document.querySelector(qs).style.display = 'block';
      } catch (err) {}
    }
  }, {
    key: "attachMeta",
    value: function attachMeta(app) {}
  }, {
    key: "attachStyleSheets",
    value: function attachStyleSheets() {
      var _this2 = this;
      if (this.stylesheetAdded === true) return;
      this.styles.forEach(function (stylesheet) {
        var should_attach_sheet = true;
        document.querySelectorAll('link').forEach(function (el) {
          try {
            if ((el === null || el === void 0 ? void 0 : el.rel) === 'stylesheet' && el.attributes.href.nodeValue.includes(stylesheet)) {
              should_attach_sheet = false;
            }
          } catch (err) {}
        });
        if (should_attach_sheet) {
          var s = document.createElement('link');
          s.rel = 'stylesheet';
          s.type = 'text/css';
          s.href = stylesheet + '?v=' + _this2.app.build_number;
          document.querySelector('head').appendChild(s);
        }
      });
      this.stylesheetAdded = true;
    }
  }, {
    key: "attachScripts",
    value: function attachScripts() {
      var _this3 = this;
      if (this.scriptsAdded === true) {
        return;
      }
      this.scriptsAdded = true;
      var scriptCount = 0;
      var _iterator = _createForOfIteratorHelper(this.scripts),
        _step;
      try {
        var _loop2 = function _loop2() {
          var script = _step.value;
          var script_attached = false;
          document.querySelectorAll('script').forEach(function (el) {
            try {
              if (el.attributes.src.nodeValue === script) {
                script_attached = true;
              }
            } catch (err) {}
          });
          scriptCount++;
          if (!script_attached) {
            _this3.attachScript(script);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "attachScript",
    value: function attachScript(script) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = script + '?v=' + _this4.app.build_number;
        s.addEventListener('load', function () {
          console.info('Script loaded dynamically');
          resolve();
        });
        s.addEventListener('error', function () {
          console.error('Error loading script');
          reject();
        });
        document.querySelector('head').appendChild(s);
      });
    }
  }, {
    key: "attachPostScripts",
    value: function attachPostScripts() {
      if (this.postScriptsAdded === true) {
        return;
      }
      this.postScripts.forEach(function (script) {
        var script_attached = false;
        document.querySelectorAll('script').forEach(function (el) {
          try {
            if (el.attributes.src.nodeValue === script) {
              script_attached = true;
            }
          } catch (err) {}
        });
        if (!script_attached) {
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.src = script;
          s.type = 'module';
          document.querySelector('body').appendChild(s);
        }
      });
      this.postScriptsAdded = true;
    }
  }, {
    key: "removeScripts",
    value: function removeScripts() {
      this.scripts.forEach(function (script) {
        console.info('removing script', script);
        // $(`script[src*="${script}"]`).remove();
      });
      this.scriptsAdded = false;
    }
  }, {
    key: "removeStyleSheets",
    value: function removeStyleSheets(app) {
      this.stylesheets.forEach(function (stylesheet) {
        console.info('removing stylesheet ', stylesheet);
        // $(`link[rel=stylesheet][href~="${stylesheet}"`).remove();
      });
      this.stylesheetAdded = false;
    }
  }, {
    key: "removeMeta",
    value: function removeMeta() {}
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      this.eventListeners.forEach(function (eventListener) {
        document.removeEventListener(eventListener.type, eventListener.listener);
      });
    }
  }, {
    key: "destroy",
    value: function destroy(app) {
      console.trace('destroying');
      // this.removeMeta();
      // this.removeStyleSheets();
      // this.removeHTML();
      // this.removeScripts();
      // this.removeEvents();
      // this.stylesheets = null;
      // this.stylesheetAdded = false;
      // this.scriptsAdded = false;
      // this.browser_active = 0;
    }
  }, {
    key: "displayModal",
    value: function displayModal(modalHeaderText) {
      var modalBodyText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      //salert is not async!
      salert("".concat(modalHeaderText).concat(modalBodyText ? ': <br>' : '').concat(modalBodyText));
    }
  }, {
    key: "displayWarning",
    value: function displayWarning(warningTitle) {
      var warningText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4000;
      var html = "<div class=\"game_warning_overlay\">\n                  <div class=\"game_warning_header\">\n                    <i class=\"fas fa-exclamation-triangle\"></i>\n                    <div class=\"game_warning_timer\" >Auto close in <span id=\"clock_number\">".concat(Math.ceil(time / 1000), "</span>s</div> \n                  </div>\n                  <h2>").concat(warningTitle, "</h2>\n                  <p ").concat(warningText.length == 0 ? "style='flex:1;'" : "style='flex:2;'", ">").concat(warningText, "</p>\n                </div>");
      var overlay_self = this.overlay;
      var timeouthash = null,
        intervalHash = null;
      if (time > 0) {
        timeouthash = setTimeout(function () {
          overlay_self.hide();
          clearInterval(intervalHash);
        }, time);
        intervalHash = setInterval(function () {
          time -= 250;
          try {
            document.getElementById('clock_number').innerHTML = Math.ceil(time / 1000);
          } catch (err) {}
        }, 250);
      }
      this.overlay.show(html, function () {
        if (timeouthash) {
          clearTimeout(timeouthash);
        }
        if (intervalHash) {
          clearInterval(intervalHash);
        }
      });
    }
  }, {
    key: "hasSeenTransaction",
    value: function hasSeenTransaction(tx) {
      var blk_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var hashed_data = this.name + tx.signature;
      if (this.processedTxs[hashed_data] !== undefined) {
        if (this.processedTxs[hashed_data]) {
          var _tx$from$;
          console.debug('prevent processing duplicated on chain transaction : ', (_tx$from$ = tx.from[0]) === null || _tx$from$ === void 0 ? void 0 : _tx$from$.publicKey, tx.returnMessage(), this.processedTxs[hashed_data], blk_id);
        }
        this.processedTxs[hashed_data] = blk_id;
        return true;
      }
      this.processedTxs[hashed_data] = blk_id;
      return false;
    }
  }, {
    key: "getWebsocketPath",
    value: function getWebsocketPath() {
      return '';
    }
  }, {
    key: "onWebSocketServer",
    value: function onWebSocketServer(wss) {
      // wss.on('connection', (socket, request) => {
      //  socket.on('message', (msg) => {
      //  });
      //  socket.on('close', () => {});
      //  socket.on('error', (err) => {});
      // });
    }
  }], [{
    key: "importFunctions",
    value: function importFunctions() {
      var cls = this.prototype;
      var mixin;
      for (var arg = 0; arg < arguments.length; arg++) {
        mixin = arguments[arg].prototype;
        if (typeof mixin != 'undefined') {
          Object.getOwnPropertyNames(mixin).forEach(function (prop) {
            if (prop == 'constructor') return;
            if (Object.getOwnPropertyNames(cls).includes(prop)) {
              console.warn('Module already includes ' + prop);
              return;
            }
            cls[prop] = mixin[prop];
          });
        }
      }
    }
  }]);
}();
module.exports = ModTemplate;